import Box from "@material-ui/core/Box"
import Checkbox from "@material-ui/core/Checkbox"
import CircularProgress from "@material-ui/core/CircularProgress"
import Typography from "@material-ui/core/Typography"
import Alert from "@material-ui/lab/Alert"
import { useAppContext } from "../../../app-context/use-app-context"
import { useGetHourReportSettingsQuery, useUpdateHourReportSettingsMutation } from "../../api"
import { useAdminOwnHoursReviewSettingTranslations } from "./use-translations"

const AdminOwnHoursReviewSettingCheckbox = () => {
  const orgId = useAppContext().appContext.mainContext?.id as string
  const translations = useAdminOwnHoursReviewSettingTranslations()
  const { data, isLoading, isError } = useGetHourReportSettingsQuery(orgId)
  const [updateSettings, { isLoading: isSaving, isError: isSaveError }] = useUpdateHourReportSettingsMutation()

  if (isLoading) return <CircularProgress size={24} />

  if (isError || !data) {
    return <Alert severity="error">{translations.loadError}</Alert>
  }

  return (
    <>
      {isSaveError && (
        <Box mb={2}>
          <Alert severity="error">{translations.saveError}</Alert>
        </Box>
      )}

      <Box display="flex" alignItems="flex-start">
        <Checkbox
          checked={data.hourReportSettings.allowAdminsToCheckAndApproveOwnHours}
          color="primary"
          disabled={!data.canUpdateAdminSelfReview || isSaving}
          inputProps={{ "aria-label": translations.label }}
          onChange={(event) => updateSettings({ orgId, allowAdminsToCheckAndApproveOwnHours: event.target.checked })}
        />
        <Box ml={1} mt={0.5}>
          <Typography variant="subtitle1">{translations.label}</Typography>
          <Typography variant="body2" color="textSecondary">
            {translations.description}
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default AdminOwnHoursReviewSettingCheckbox
